import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	detailsTabTitle: {
		id: 'servicedesk-insight-object-details.details-tab-title',
		defaultMessage: 'Details',
		description: 'Header title for the details tab panel shown in the object view.',
	},
	activityTabTitle: {
		id: 'servicedesk-insight-object-details.activity-tab-title',
		defaultMessage: 'Activity',
		description: 'Header title for the activity timeline tab panel shown in the object view.',
	},
});

export default messages;
